import api from "./api";

export const getFeatureEvents = (city) => {
  return api.get(`/event/searchFeature/${city}`);
};

export const getEventsByCategory = (categoryId, city, eventInParentCategory) => {
  return api.post("/event/search", {
    categoryId: categoryId,
    city:city,
    eventInParentCategory: eventInParentCategory,
  });
};

export const getUpcomingEvents = (city) => {
  return api.get(`/event/upcomingEvents/${city}`);
};

export const getGenres = () => {
  return api.get("/genre");
};

export const getLanguages = () => {
  return api.get("/language/getAll");
};

export const getCitiesByCountry = (countryId) => {
  return api.get(`/cityCountry/countryId/${countryId}`);
};

export const getAllCategories = () => {
  return api.get("/event-category/all-categories");
};

export const createEvent = (data) => {
  return api.post("/event/add", data);
};

export const searchArtist = (partialName) => {
  return api.get(`/event-artist/search?partialName=${partialName}`);
};

export const createEventArtist = (data) => {
  return api.post("/event-artist", data);
};

export const searchVenueSchedule = (searchText) => {
  return api.get(`/event-venue-schedule/search?searchText=${searchText}`);
};

export const createEventVenue = (data) => {
  return api.post("/event-venue-schedule", data);
};

export const getEventPreview = (eventId) => {
  return api.get(`/event/get/${eventId}`);
};